module.exports = __webpack_public_path__ + "img/brightness-low-fill.61dd9261.svg";